<template>
    <div
        class="h-screen w-full pt-[100px] tablet:pt-[200px] laptop:pt-0 flex items-start laptop:items-center justify-center mobile:-mt-[112px] laptop:-mt-[96px] desktop:-mt-[64px] largeDesktop:-mt-[80px] desktop:overflow-hidden">
        <div
            class="relative text-center rounded-[10px] shadow-[0px_0px_10px_0px_#0000001A] border-[10px] border-[#fff] bg-[#fff] max-w-[500px]">
            <div
                class="relative z-10 py-[30px] px-[20px] tablet:px-[40px] rounded-[10px] border-[1px] border-customBlue-100">
                <div class="flex justify-center">
                    <img src="../../../assets/images/happyHomeLogo.svg" alt="Partner Logo"
                        class="w-[100px] h-[100px]  rounded-full border-[3px] border-[#fff]">
                </div>
                <h2 class="my-[15px] font-roboto text-[50px] font-semibold text-customBlue-100">Thank You</h2>
                <p class="my-[15px] font-roboto text-[20px] font-semibold text-customYellow-100">Order ID: {{
                    $route?.query?.order_id ?? '-' }}</p>
                <h6 class="m-0 font-roboto text-[25px] font-medium text-[#333]">Congratulations!</h6>
                <p class="m-0 font-roboto text-[16px] font-normal text-[#333]">We’re setting everything up on our end.
                    Your plan will officially activate in 30 days.
                </p>
                <button @click="onContinueClicked()"
                    class="mt-[20px] px-[30px] py-[10px] rounded-full text-roboto text-[15px] font-semibold CustomBlueBtn">Continue</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bgImage: require('../../../assets/images/thankuSecBg.svg')
        };
    },
    mounted() {
        document.documentElement.classList.add('desktop:!overflow-hidden');
    },
    methods: {
        onContinueClicked() {
            this.$router.replace("/protection-plan/sales-history")
        }
    }
};
</script>